import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Survey } from '../../form/props';

export const useSurveyRegisterHistory = (survey?: Survey) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: () => {
            // No action needed
        },
    });

    useEffect(() => {
        const { createdBy, updatedBy } = survey || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [survey]);

    return {
        formik,
    };
};
